import { defineRouting } from 'next-intl/routing';

/**
 * Marathi is the default locale (Marathi-first mandate).
 * `as-needed` keeps the default locale prefix-free is NOT used here on purpose:
 * a govt portal benefits from explicit, shareable locale URLs (/mr, /hi, /en).
 */
export const locales = ['mr', 'hi', 'en'] as const;
export type Locale = (typeof locales)[number];

export const localeLabels: Record<Locale, string> = {
  mr: 'मराठी',
  hi: 'हिंदी',
  en: 'English',
};

export const routing = defineRouting({
  locales,
  defaultLocale: 'mr',
  localePrefix: 'always',
});
